<div class="wrapper-reponsive src-personal-inf-inp">
    <!-- Start màn 8 -->
    <div class="tlt-green-row mt-3">
        {{'STR_MEDICAL_EXAM_RESERVATION' | translate}}
    </div>
    <div class="content-box mt-2 mb-3 p-3" *ngIf="typeMode !== 3">
        <div class="process-step">
            <p>Step</p>
            <ul>
                <li class="active">
                    <div class="circle">
                        <span class="num">1</span>
                    </div>
                </li>
                <li class="active">
                    <div class="circle">
                        <span class="num">2</span>
                    </div>
                </li>
                <li class="active">
                    <div class="circle">
                        <span class="num">3</span>
                    </div>
                </li>
                <li>
                    <div class="circle">
                        <span class="num">4</span>
                    </div>
                </li>
                <li>
                    <div class="circle">
                        <span class="num">5</span>
                    </div>
                </li>
                <li>
                    <div class="circle">
                        <span class="num">6</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="content-box mt-2 mb-2">
        <div class="tlt-border mb-1">
            {{'STR_ENTER_EXAMINEE_INFOR' | translate}}
        </div>
        <p class="p-2 mb-1">
            {{'STR_ENTER_EXAMINEE_INFOR_PL' | translate}}
        </p>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_NAME' | translate}}
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <input type="text" class="form-control" autocomplete="off" [(ngModel)]="objUser.ConsulName" id="ConsulName"
                    maxlength="80" [ngClass]="{'error-border': isConsulName && util.isNullOrEmpty(objUser.ConsulName)}" (keydown)="changeConsulName()">
                <span *ngIf="isConsulName && util.isNullOrEmpty(objUser.ConsulName)" class="text-error">
                    {{util.stringFormat([trans.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED'),
                    trans.instant('STR_NAME')])}}
                </span>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2" *ngIf="isShowKanaName">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_KANA_NAME' | translate}}
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <input type="text" [placeholder]="'STR_KANA_NAME_PLACEHOLDER' | translate" class="form-control"
                    autocomplete="off" [(ngModel)]="objUser.KanaName" maxlength="80" id="KanaName" (keypress)="onKeyPressInput($event)"
                    [ngClass]="{'error-border': (isKanaName && util.isNullOrEmpty(objUser.KanaName)) || isKanaName2}" (keydown)="changeKanaName()">
                <span *ngIf="isKanaName && util.isNullOrEmpty(objUser.KanaName)" class="text-error">
                    {{util.stringFormat([trans.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED'),
                    trans.instant('STR_KANA_NAME')])}}
                </span>
                <span *ngIf="isKanaName2 && !util.isNullOrEmpty(objUser.KanaName)" class="text-error">
                    {{'MESS_ERR_KANA_ONLY' | translate}}
                </span>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_DATEOFBIRTH' | translate}}
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <app-date-inp [strDate]="objUser.DateOfBirth" [ngClass]="{'error-border': isDateOfBirth && util.isNullOrEmpty(objUser.DateOfBirth)}"
                    (evReturn)="ChangeDOB1($event)" (eRemove)="removeBoderDateOfBirth()" [strId]="'DateOfBirth'"></app-date-inp>
                <span *ngIf="isDateOfBirth && util.isNullOrEmpty(objUser.DateOfBirth)" class="text-error">
                    {{util.stringFormat([trans.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED'),
                    trans.instant('STR_DATEOFBIRTH')])}}
                </span>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_GENDER' | translate}}
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <div class="row mt-2">
                    <div class="col-4">
                        <label class="custom-radio">{{'STR_GENDER_MALE' | translate}}
                            <input type="radio" name="radio" id="1" [(ngModel)]="objUser.Gender" [value]="'1'" id="Gender">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <div class="col-4">
                        <label class="custom-radio">{{'STR_GENDER_FEMALE' | translate}}
                            <input type="radio" name="radio" id="2" [(ngModel)]="objUser.Gender" [value]="'2'">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
                <span *ngIf="isGender && util.isNullOrEmpty(objUser.Gender)" class="text-error">
                    {{util.stringFormat([trans.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED'),
                    trans.instant('STR_GENDER')])}}
                </span>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_PHONENUM' | translate}}
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <app-phone-number [length]="13" [inValue]="objUser.PhoneNum" (newItemEvent)="setValuePhoneNum($event)"
                    [isError]="isPhoneNum" [strId]="'PhoneNum'" (removeErrorEvent)="removeErrorPhone()">
                </app-phone-number>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3 mb-2">
                <div class="tlt-dot mb-1">{{'STR_ADDRESS' | translate}}
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <div>
                    <!-- 20250120 #18640 modify start -->
                    <!-- <input type="text" class="form-control d-inline-block w200 mr-2" autocomplete="off" id="PostalCode"
                        [(ngModel)]="objUser.PostalCode" postalForm numberForm maxlength="10" placeholder="{{'STR_POSTALNUM' | translate}}"
                        [ngClass]="{'error-border': isPostalCode && util.isNullOrEmpty(objUser.PostalCode)}" (keydown)="changePostalCode()"> -->
                    <!-- 20250208 #18640 modify start -->
                    <!-- <input type="text" class="form-control d-inline-block w200 mr-2" autocomplete="off" id="PostalCode"
                        [(ngModel)]="objUser.PostalCode" postalForm numberForm maxlength="7" placeholder="{{'STR_POSTALNUM' | translate}}"
                        [ngClass]="{'error-border': isPostalCode && util.isNullOrEmpty(objUser.PostalCode)}" (keydown)="changePostalCode()"> -->
                    <input type="text" class="form-control d-inline-block w200 mr-2" autocomplete="off" id="PostalCode"
                        [(ngModel)]="objUser.PostalCode" postalForm numberForm maxlength="10" placeholder="{{'STR_POSTALNUM' | translate}}"
                        [ngClass]="{'error-border': isPostalCode && util.isNullOrEmpty(objUser.PostalCode)}" (keydown)="changePostalCode()">
                    <!-- 20250208 #18640 modify end -->
                    <!-- 20250120 #18640 modify end -->    
                    <button class="btn-search-green" (click)="SearchAddress()">
                        <img src="../../../../../assets/img/icon_search.png" alt="">
                    </button>
                </div>
                <span *ngIf="isPostalCode && util.isNullOrEmpty(objUser.PostalCode)" class="text-error">
                    {{util.stringFormat([trans.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED'),
                    trans.instant('STR_POSTALNUM')])}}
                </span>
            </div>
            <div class="pl-3">
                <app-inp-postal-code [data]="lstPostal" (outPostal)="SetValueAddress($event)" [maxLength]="'255'"
                    [isError]="isAdress1" [idInp]="'Adress1'" (removeErrorEvent)="removeErrorAdress()">
                </app-inp-postal-code>
            </div>
            <div class="pl-3">
                <input type="text" class="form-control mt-2" autocomplete="off" [(ngModel)]="objUser.Adress2" id="Adress2"
                    maxlength="255" placeholder="{{'STR_NEXT_ADDRESS_PLACEHOLDER' | translate}}">
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_EMAIL_ADDRESS' | translate}}
                </div>
                <p class="pl-2 pr-2 m-0">
                    {{objUser.MailAdress}}
                </p>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-4">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_REQUEST_NOTE' | translate}}
                </div>
                <p class="p-2">
                    {{'STR_REQUEST_NOTE_INFOR' | translate}}
                </p>
                <textarea name="" class="form-control" id="" rows="3" autocomplete="off" id="WebRsvNote"
                    [(ngModel)]="objUser.WebRsvNote"></textarea>
            </div>
        </div>
        <div class="text-center lst-button-flex mt-2">
            <button class="btn btn-common btn-bg-yellow mr-2 ml-2 mb-2" (click)="ButtonBack()">
                {{'STR_BTN_BACK' | translate}}
            </button>
            <button class="btn btn-common btn-bg-green mr-2 ml-2 mb-2" (click)="ButtonNext()" *ngIf="typeMode === 1">
                {{'STR_BTN_THE_NEXT' | translate}}
            </button>
            <button class="btn btn-common btn-bg-green mr-2 ml-2 mb-2" *ngIf="typeMode !== 1" (click)="ButtonEdit()" [disabled]="!checkChangeData()">
                {{'STR_BTN_EDIT' | translate}}
            </button>
        </div>
    </div>
    <!-- End màn 8 -->
</div>